<template>
  <div :id="tender.id" class="tender-card">
    <router-link
      :to="{ name: 'tender-summary', params: { tenderId: this.tender.id } }"
      tag="div"
      class="tender-main-section"
    >
      <div class="tender-main-info spacey-8">
        <div class="tender-title spacex-8">
          <router-link
            :to="{ name: 'tender-summary', params: { tenderId: this.tender.id } }"
            class="tender-title-link no-link"
          >
            <span class="tender-title-text">{{ tender.name }}</span>
          </router-link>
          <v-tooltip
            v-if="tender.description"
            bottom
            max-width="345"
            transition="scroll-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <InfoIcon v-bind="attrs" class="pointer no-outline" v-on="on" @click.stop />
            </template>
            <div>
              {{ tender.description }}
            </div>
          </v-tooltip>
        </div>
        <div class="tender-description spacex-16">
          <div class="tender-info spacex-4">
            <span class="text text-grey">{{ $t('Offers deadline') }}</span>
            <span class="text primary no-wrap">{{ offerDate }}</span>
          </div>
          <div class="tender-info spacex-4">
            <span class="text text-grey">{{ $t('Public budget') }}</span>
            <span class="text primary no-wrap">
              {{ currencySymbols[tender.currency] }}
              {{ addSpaces(tender.public_budget) }}
            </span>
          </div>
        </div>
      </div>
      <div class="tender-info-block tender-offers spacey-4">
        <TenderCardOffersBadge :tender="tender" />
        <TenderCardCompaniesInfo
          v-if="tenderCompanies.length"
          :tender="tender"
          :show-extended-info="showExtendedInfo"
          @switch-extended-info="switchExtendedInfo"
        />
      </div>
      <TenderCardActionsRow
        :tender="tender"
        class="spacex-20"
        @update-tenders="(e) => $emit('update-tenders', e)"
      />
    </router-link>
    <div v-if="showExtendedInfo" class="tender-extend-section">
      <CompaniesTable v-if="tenderCompanies.length" :companies="tenderCompanies" />
    </div>
  </div>
</template>

<script>
  import CompaniesTable from '@/components/tenders/CompaniesTable';
  import TenderCardActionsRow from '@/components/tenders/tender-card/TenderCardActionsRow';
  import prettyDates from '@/utils/formatting/pretty-date';
  import InfoIcon from '@/assets/icons/info.svg';
  import addSpaces from '@/utils/formatting/add-spaces';
  import EditIcon from '@/assets/icons/edit.svg';
  import editTender from '@/utils/mixins/edit-tender';
  import { VTooltip } from 'vuetify/lib';
  import TenderCardOffersBadge from '@/components/tenders/tender-card/TenderCardOffersBadge';
  import TenderCardCompaniesInfo from '@/components/tenders/tender-card/TenderCardCompaniesInfo';
  import { mapState } from 'vuex';

  export default {
    name: 'TenderCard',
    components: {
      TenderCardCompaniesInfo,
      TenderCardOffersBadge,
      TenderCardActionsRow,
      CompaniesTable,
      VTooltip,
      InfoIcon,
    },
    mixins: [editTender],
    props: {
      title: {
        type: String,
      },
      tender: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showExtendedInfo: false,
        editIcon: EditIcon,
      };
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      offerDate() {
        return prettyDates({
          start: new Date(this.tender.offers_deadline_date),
          end: new Date(this.tender.offers_deadline_date),
        });
      },
      tenderCompanies() {
        return this.tender?.offers || [];
      },
    },
    methods: {
      addSpaces,
      prettyDates,
      switchExtendedInfo() {
        this.showExtendedInfo = !this.showExtendedInfo;
      },
    },
  };
</script>
